<template>
    <div class="w-1/2 mb-4">
        <div class="border border-orange-200 bg-orange-100 rounded-xl p-6">
            <b>{{user.email}}</b>
            <template v-if="user.hasSuspiciousDomain">
                <p class="text-sm">
                    {{translate('needs_your_approval')}}
                </p>

                <a href="" class="btn btn-primary btn-sm mt-6"  v-on:click.prevent="acceptLimitedUser">{{translate('opties')}}</a>
            </template>
            <template v-else>
                <p class="text-sm">
                    {{translate('non_active_because_limit_exceeded')}} 
                </p>

                <div class="mt-6 gap-5 flex">
                    <a href="" class="btn btn-primary btn-sm" v-on:click.prevent="acceptLimitedUser()">{{translate('reactivate_user')}}</a>
                    <a href="" class="btn btn-danger btn-sm" v-on:click.prevent="rejectLimitedUser()">{{translate('deactivate_user')}}</a>
                </div>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
    import {defineComponent} from 'vue';
    import {useAccountStore} from "../store";
    import { User } from './types';
   
    export default defineComponent({
        name: 'needs-review-user',
        props: {
            user: {
                type: Object as () => User,
                required: true
            }
        },
        data() {
            return {
                accountStore: useAccountStore()
            };
        },
        methods: {
            async acceptLimitedUser() {
                await this.accountStore.reactivateUser(this.user);
            },
            async rejectLimitedUser(): Promise<void> {
                await this.accountStore.deactivateUser(this.user);
            }
        }
    });
</script>